<template>
  <div class="footer-container">
    <div class="footer-separator">
      <div class="separator-line"></div>
      <div class="separator-icon">
        <i class="bi bi-chevron-down"></i>
      </div>
    </div>
    <footer class="contact">
      <div class="box">
        <div class="above">
          <div class="wechat">
            <img src="@/assets/wechat_code.jpg" alt="扫描关注俊采猎头微信公众账号" />
            <p class="scan-text">扫码关注微信</p>
          </div>
          <div class="left">
            <h3 class="footer-title">联系方式</h3>
            <div class="location">
              <i class="bi bi-geo-alt-fill"></i> 中国<span class="separator"></span>上海<span class="separator"></span>普陀区
            </div>
            <div class="contact-item">
              <i class="bi bi-truck"></i> 供应链、物流：
              <a href="tel:021-63806309" class="tel-link">021-63806309</a>
            </div>
            <div class="contact-item">
              <i class="bi bi-lightning-charge-fill"></i> 新能源、电力：
              <a href="tel:021-63800880" class="tel-link">021-63800880</a>
            </div>
            <div class="contact-item">
              <i class="bi bi-laptop"></i> 互联网、电子商务：
              <a href="tel:021-63800212" class="tel-link">021-63800212</a>
            </div>
            <div class="contact-item address">
              <i class="bi bi-building"></i> 地址：上海市普陀区中山北路华源世界大厦
            </div>
            <div class="contact-item zipcode">
              <i class="bi bi-envelope-fill"></i> 邮编：200063
            </div>
            <div class="job-link-wrapper">
              <a href="mailto:rober.liu@jc-talent.com" target="_blank" class="job">
                <i class="bi bi-person-plus-fill"></i> 工作机会
              </a>
            </div>
          </div>
          <div class="right"> 
            <h3 class="footer-title">关于我们</h3>
            <div class="about-item">
              <i class="bi bi-globe2"></i> 网址：
              <a href="https://www.jc-talent.com" target="_blank" class="link">www.jc-talent.com</a>
            </div>
            <div class="about-item">
              <i class="bi bi-envelope"></i> Email：
              <a href="mailto:admin@jc-talent.com" class="link">admin@jc-talent.com</a>
            </div>
            <div class="social-links">
              <a href="https://www.linkedin.com/company/jc-talent" target="_blank" class="social-link"><i class="bi bi-linkedin"></i></a>
              <a href="javascript:void(0)" @click="showWechat" class="social-link"><i class="bi bi-wechat"></i></a>
              <a href="mailto:admin@jc-talent.com" class="social-link"><i class="bi bi-envelope"></i></a>
            </div>
            <div class="copyright">
              <i class="bi bi-c-circle"></i> {{ new Date().getFullYear() }} 版权所有<br>上海俊采企业管理咨询有限公司
            </div>
            <div class="icp">
              <i class="bi bi-shield-check"></i> 沪ICP备13038978号
            </div>
          </div>
        </div>
        
        <div class="divider"></div>
        
        <div class="footer-bottom">
          <div class="company-slogan">专业人才招聘顾问 · 助力企业成长</div>
          <div class="footer-nav">
            <router-link to="/" class="footer-nav-link">首页</router-link>
            <router-link to="/about" class="footer-nav-link">关于我们</router-link>
            <router-link to="/business" class="footer-nav-link">服务项目</router-link>
            <router-link to="/clients" class="footer-nav-link">成功案例</router-link>
            <router-link to="/contact" class="footer-nav-link">联系我们</router-link>
          </div>
        </div>
      </div>
    </footer>
    
    <!-- 完全重写悬浮按钮 -->
    <div class="float-tools">
      <!-- 工具按钮 -->
      <div class="float-buttons" v-show="isOpen">
        <!-- 回到顶部 -->
        <div class="float-btn" @click.prevent="scrollToTop()">
          <i class="bi bi-arrow-up"></i>
          <span class="tooltip">回到顶部</span>
        </div>
        
        <!-- 在线咨询 -->
        <div class="float-btn" @click="openChat">
          <i class="bi bi-chat-dots"></i>
          <span class="tooltip">在线咨询</span>
        </div>
        
        <!-- 电话咨询 -->
        <div class="float-btn" @click="showPhone">
          <i class="bi bi-telephone"></i>
          <span class="tooltip">电话咨询</span>
          <!-- 电话弹窗 -->
          <div class="float-popup" v-if="showPhonePopup">
            <div class="popup-title">联系我们</div>
            <div class="popup-content">
              <div>供应链、物流：</div>
              <a href="tel:021-63806309">021-63806309</a>
              <div>互联网：</div>
              <a href="tel:021-63800212">021-63800212</a>
            </div>
          </div>
        </div>
        
        <!-- 微信咨询 -->
        <div class="float-btn" @click="showWechat">
          <i class="bi bi-wechat"></i>
          <span class="tooltip">微信咨询</span>
          <!-- 微信弹窗 -->
          <div class="float-popup wechat-popup" v-if="showWechatPopup">
            <div class="popup-title">扫码关注</div>
            <div class="popup-content">
              <img src="@/assets/wechat_code.jpg" alt="微信二维码">
            </div>
          </div>
        </div>
        
        <!-- 前往底部 -->
        <div class="float-btn" @click.prevent="scrollToBottom()">
          <i class="bi bi-arrow-down"></i>
          <span class="tooltip">前往底部</span>
        </div>
      </div>
      
      <!-- 主开关 - 移到下面保持位置固定 -->
      <div class="float-toggle" @click="toggleTools">
        <i class="bi" :class="isOpen ? 'bi-x' : 'bi-list'"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
  data() {
    return {
      isOpen: true,
      showPhonePopup: false,
      showWechatPopup: false
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    scrollToTop() {
      try {
        // 原生DOM方法滚动到顶部 - 更可靠的实现
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0; // 兼容Safari
        
        // 平滑滚动效果（作为后备方案）
        if (typeof window.scrollTo === 'function') {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      } catch (e) {
        // 故障恢复：最原始的方法
        window.scrollTo(0, 0);
      }
    },
    scrollToBottom() {
      try {
        const docHeight = Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight,
          document.body.offsetHeight,
          document.documentElement.offsetHeight
        );
        
        // 使用最可靠的滚动方法
        document.documentElement.scrollTop = docHeight;
        document.body.scrollTop = docHeight; // 兼容Safari
        
        // 平滑滚动效果（作为后备方案）
        if (typeof window.scrollTo === 'function') {
          window.scrollTo({
            top: docHeight,
            behavior: 'smooth'
          });
        }
      } catch (e) {
        // 故障恢复：最原始的方法
        window.scrollTo(0, document.body.scrollHeight);
      }
    },
    toggleTools() {
      this.isOpen = !this.isOpen;
      // 切换时关闭所有弹窗
      this.showPhonePopup = false;
      this.showWechatPopup = false;
    },
    openChat() {
      window.open('tencent://message/?uin=274008097&Site=www.jc-talent.com&Menu=yes', '_blank');
    },
    // 电话咨询点击事件
    showPhone(event) {
      event.stopPropagation(); // 阻止事件冒泡
      this.showWechatPopup = false; // 关闭微信弹窗
      this.showPhonePopup = !this.showPhonePopup; // 切换电话弹窗状态
    },
    
    // 微信咨询点击事件
    showWechat(event) {
      event.stopPropagation(); // 阻止事件冒泡
      this.showPhonePopup = false; // 关闭电话弹窗
      this.showWechatPopup = !this.showWechatPopup; // 切换微信弹窗状态
    },
    // 处理点击外部关闭所有弹窗
    handleOutsideClick(event) {
      const toolsEl = this.$el.querySelector('.float-tools');
      if (!toolsEl.contains(event.target)) {
        this.showPhonePopup = false;
        this.showWechatPopup = false;
      }
    }
  }
}
</script>

<style scoped>
.footer-container {
  position: relative;
  font-family: "Helvetica Neue", Arial, sans-serif;
  margin-top: 10px;
}

/* 新的分隔符设计 */
.footer-separator {
  position: relative;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: -30px;
}

.separator-line {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, rgba(44,62,80,0.1), rgba(44,62,80,0.5), rgba(44,62,80,0.1));
}

.separator-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 50%;
  border: 1px solid rgba(44,62,80,0.2);
  position: relative;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.separator-icon i {
  color: #2c3e50;
  font-size: 18px;
}

.contact {
  background: linear-gradient(135deg, #2c3e50 0%, #1a252f 100%);
  color: #fff;
  padding: 60px 0 40px;
  position: relative;
  z-index: 0;
  overflow: hidden;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 -5px 15px rgba(0,0,0,0.05);
}

.contact:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: radial-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 20px 20px;
  z-index: -1;
  opacity: 0.3;
}

.box {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
}

.above {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.footer-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px;
  position: relative;
  padding-bottom: 10px;
  letter-spacing: 1px;
}

.footer-title:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 3px;
  background: linear-gradient(90deg, #009688, #4CAF50);
  transition: width 0.3s ease;
}

.wechat {
  width: 120px;
}

.wechat img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  border: 3px solid rgba(255, 255, 255, 0.1);
}

.wechat img:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
}

.scan-text {
  text-align: center;
  margin-top: 10px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
}

.left {
  flex: 1;
  padding: 0 30px;
  font-size: 14px;
  line-height: 1.8;
}

.location {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.separator {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #009688;
  margin: 0 10px;
}

.contact-item {
  margin-bottom: 10px;
  display: block;
  align-items: center;
}

.contact-item i {
  color: #4CAF50;
  margin-right: 10px;
  font-size: 16px;
}

.tel-link {
  color: #fff;
  text-decoration: none;
  transition: color 0.3s ease;
  font-weight: 500;
  position: relative;
  padding-bottom: 2px;
}

.tel-link:after {
  content: '';
  position: absolute;
  width: 0;
  height: 1px;
  bottom: 0;
  left: 0;
  background-color: #4CAF50;
  transition: width 0.3s ease;
}

.tel-link:hover {
  color: #4CAF50;
}

.tel-link:hover:after {
  width: 100%;
}

.address, .zipcode {
  margin-top: 15px;
}

.job-link-wrapper {
  margin-top: 20px;
}

.job {
  display: inline-block;
  align-items: center;
  background: rgba(0, 150, 136, 0.2);
  color: #fff;
  padding: 8px 15px;
  border-radius: 20px;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 150, 136, 0.3);
}

.job:hover {
  background: #009688;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.job i {
  margin-right: 8px;
}

.right {
  width: 250px;
  font-size: 14px;
  line-height: 1.8;
}

.about-item {
  display: block;
  align-items: center;
  margin-bottom: 10px;
}

.about-item i {
  color: #4CAF50;
  margin-right: 10px;
  font-size: 16px;
}

.link {
  color: #fff;
  text-decoration: none;
  transition: color 0.3s ease;
  position: relative;
  padding-bottom: 2px;
}

.link:after {
  content: '';
  position: absolute;
  width: 0;
  height: 1px;
  bottom: 0;
  left: 0;
  background-color: #4CAF50;
  transition: width 0.3s ease;
}

.link:hover {
  color: #4CAF50;
}

.link:hover:after {
  width: 100%;
}

.social-links {
  display: flex;
  gap: 12px;
  margin: 20px 0;
}

.social-link {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.social-link:hover {
  background: #009688;
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.copyright, .icp {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  margin-bottom: 5px;
}

.copyright i, .icp i {
  font-size: 14px;
  margin-right: 5px;
}

.divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 20px 0;
  position: relative;
}

.divider:before {
  content: "";
  position: absolute;
  width: 100px;
  height: 3px;
  background: linear-gradient(90deg, #009688, transparent);
  top: -1px;
  left: 50%;
  transform: translateX(-50%);
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  flex-wrap: wrap;
  margin-top: 10px;
}

.company-slogan {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  font-style: italic;
  margin-bottom: 10px;
}

.footer-nav {
  display: flex;
  gap: 25px;
  flex-wrap: wrap;
}

.footer-nav-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 15px;
  transition: all 0.3s ease;
  position: relative;
  padding: 5px 0;
  font-weight: 500;
}

.footer-nav-link:after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #4CAF50;
  transition: width 0.3s ease;
}

.footer-nav-link:hover {
  color: #fff;
}

.footer-nav-link:hover:after {
  width: 100%;
}

/* 全新的悬浮工具样式 */
.float-tools {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.float-toggle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #009688 0%, #00796b 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  color: white;
  transition: transform 0.3s;
}

.float-toggle:hover {
  transform: scale(1.1);
}

.float-toggle:active {
  transform: scale(0.95);
}

.float-toggle i {
  font-size: 24px;
}

.float-buttons {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.float-btn {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: linear-gradient(135deg, #009688 0%, #00796b 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  color: white;
  transition: transform 0.3s, box-shadow 0.3s;
  margin-bottom: 10px;
  position: relative;
}

.float-btn i {
  font-size: 20px;
}

.float-btn:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(0, 150, 136, 0.3);
}

.float-btn:active {
  transform: scale(0.95);
}

.tooltip {
  position: absolute;
  right: 55px;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  padding: 5px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  visibility: hidden;
  opacity: 0;
  transition: all 0.3s;
}

.tooltip:after {
  content: '';
  position: absolute;
  right: -6px;
  top: 50%;
  transform: translateY(-50%);
  border-width: 6px 0 6px 6px;
  border-style: solid;
  border-color: transparent transparent transparent rgba(0, 0, 0, 0.8);
}

.float-btn:hover .tooltip {
  visibility: visible;
  opacity: 1;
  right: 60px;
}

.float-popup {
  position: absolute;
  right: 55px;
  top: 50%;
  transform: translateY(-50%);
  background-color: white;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 15px;
  width: 200px;
  z-index: 10000;
}

.float-popup:after {
  content: '';
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  border-width: 8px 0 8px 8px;
  border-style: solid;
  border-color: transparent transparent transparent white;
}

.popup-title {
  color: #009688;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #f0f0f0;
}

.popup-content {
  font-size: 13px;
  color: #333;
  line-height: 1.6;
}

.popup-content a {
  display: inline-block;
  color: #009688;
  text-decoration: none;
  margin: 5px 0 10px;
  padding: 5px 10px;
  border-radius: 4px;
  background-color: rgba(0, 150, 136, 0.1);
  transition: all 0.3s;
}

.popup-content a:hover {
  background-color: #009688;
  color: white;
}

.wechat-popup {
  width: 180px;
}

.wechat-popup img {
  width: 100%;
  border-radius: 4px;
  display: block;
  margin-top: 5px;
}

@media (max-width: 768px) {
  .footer-separator {
    height: 40px;
    margin-bottom: -20px;
  }
  
  .separator-icon {
    width: 34px;
    height: 34px;
  }
  
  .separator-icon i {
    font-size: 16px;
  }
  
  .contact {
    padding: 40px 0 30px;
  }
  
  .above {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  
  .wechat, .left, .right {
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .wechat {
    text-align: center;
  }
  
  .wechat img {
    width: 150px;
  }
  
  .footer-title {
    text-align: center;
  }
  
  .footer-title:after {
    left: 50%;
    transform: translateX(-50%);
  }
  
  .left, .right {
    padding: 0;
  }
  
  .social-links {
    justify-content: center;
  }
  
  .copyright, .icp {
    text-align: center;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 15px;
    text-align: center;
    padding: 15px 0;
  }
  
  .footer-nav {
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
    width: 100%;
    margin: 0 auto;
  }
  
  .footer-nav-link {
    padding: 8px 12px;
    display: inline-block;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    margin-bottom: 5px;
  }
  
  .footer-nav-link:after {
    display: none;
  }
  
  .footer-nav-link:hover {
    background-color: rgba(255, 255, 255, 0.2);
    transform: translateY(-3px);
  }
  
  .float-tools {
    right: 15px;
    bottom: 15px;
  }
  
  .float-btn, .float-toggle {
    width: 40px;
    height: 40px;
  }
  
  .float-btn i, .float-toggle i {
    font-size: 18px;
  }
  
  .float-popup {
    width: 180px;
    padding: 12px;
  }
  
  .contact-item, .about-item, .location {
    justify-content: center;
    text-align: center;
  }
  
  .contact-item i, .about-item i {
    margin-right: 8px;
  }
  
  .box {
    padding: 0 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 576px) {
  .contact {
    padding: 30px 0 20px;
  }
  
  .footer-nav {
    gap: 10px;
  }
  
  .footer-nav-link {
    font-size: 13px;
  }
  
  .float-btn, .float-toggle {
    width: 38px;
    height: 38px;
  }
  
  .float-btn i, .float-toggle i {
    font-size: 16px;
  }
  
  .float-popup {
    width: 160px;
    padding: 10px;
    right: 50px;
  }
  
  .popup-title {
    font-size: 13px;
    margin-bottom: 8px;
  }
  
  .popup-content {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .contact-item, .about-item {
    flex-direction: column;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .contact-item i, .about-item i {
    margin-right: 0;
    margin-bottom: 5px;
  }
  
  .footer-nav {
    gap: 15px;
  }
  
  .footer-nav-link {
    font-size: 14px;
  }
}
</style> 